import Vue from 'vue';
import VueRouter from 'vue-router';

import create from '../views/create';
import store from '../store';

Vue.use(VueRouter);

const ifNotAuthenticated = (to, from, next) => {
  if (!store.state.user.isAuthorized) {
    next();
    return;
  }
  next('/');
};

const ifAuthenticated = (to, from, next) => {
  store.commit('user/checkAuth');
  Vue.$cookies.set('DocLibRedirectUrl', to.path, '1h');
  if (store.state.user.isAuthorized) {
    next();
    return;
  }
  next('/login');
};

const routes = [
  {
    path: '/',
    component: () => import('../views/search')
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/login'),
    beforeEnter: ifNotAuthenticated
  },
  {
    path: '/mciVerify',
    name: 'mciVerify',
    component: () => import('../views/mci_verify.vue'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/newDocument',
    name: 'create',
    props: true,
    component: create,
    beforeEnter: (to, from, next) => {
      if (from.name !== 'mciVerify' || to.name !== 'create') {
        next('/mciVerify');
      } else {
        next();
      }
    }
  },
  {
    path: '/modify/:id/',
    name: 'modify',
    props: true,
    component: () => import('../views/modify.vue'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/document/:id/:language',
    name: 'documentDetails',
    component: () => import('../views/details')
  }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

export default router;
